const PATH_PREFIX = '/admin/:type/:targetID/announce';

export default [
  {
    name: 'announce.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'announce.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'announce.categories',
    path: `${PATH_PREFIX}/categories`,
  },
  {
    name: 'announce.category',
    path: `${PATH_PREFIX}/category/:categoryID`,
  },
  {
    name: 'announce.articles',
    path: `${PATH_PREFIX}/articles`,
  },
  {
    name: 'announce.article.detail',
    path: `${PATH_PREFIX}/article/:docID`,
  },
];
